import MJSONScreenshot from '@admin/components/mjson_screenshot'
import Button from '@admin/components/button'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Email extends React.PureComponent {

  static contextTypes = {
    admin: PropTypes.object
  }

  static propTypes = {
    action: PropTypes.string,
    config: PropTypes.object,
    campaign: PropTypes.object,
    defaultQuery: PropTypes.object,
    endpoint: PropTypes.string,
    program: PropTypes.object,
    route: PropTypes.func,
    screenshot: PropTypes.func,
    workflow: PropTypes.object,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onDone: PropTypes.func,
    onTokens: PropTypes.func
  }

  formRef = React.createRef()

  _handleCancel = this._handleCancel.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleDone = this._handleDone.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)

  constructor(props) {
    super(props)
    this.state = {
      config: props.config || {}
    }
  }

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { user } = this.context.admin
    const { defaultQuery } = this.props
    const { config } = this.state
    return {
      ref: this.formRef,
      title: 't(Send Email)',
      onChange: this._handleChange,
      onCancel: this._handleCancel,
      onSubmit: this._handleDone,
      cancelSvg: 'chevron_left',
      saveText: null,
      buttons: [
        { label: 't(Cancel)', color: 'blue', basic: true, handler: this._handleCancel },
        { label: 't(Done)', color: 'blue', handler: this._handleSubmit }
      ],
      sections: [
        {
          fields: [
            { 
              label: 't(Email)', 
              name: 'email',
              type: 'lookup', 
              required: true, 
              prompt: 'Choose an email', 
              endpoint: this._getEndpoint(), 
              valueKey: null, 
              compareKey: 'id', 
              textKey: 'title',
              form: this._getEmailForm(), 
              defaultQuery,
              defaultValue: config.email,
              after: config.email ? (
                <div className="maha-form-section-after">
                  <MJSONScreenshot { ...this._getScreenshot() } />
                  <Button { ...this._getButton() } />
                </div>
              ) : null    
            },
            {
              prompt: 't(Use warming to send this email)',
              name: 'use_warming',
              type: 'checkbox',
              show: user.type === 'support', 
              defaultValue: config.use_warming === true
            }
          ]
        }
      ]
    }
  }

  _getEmailForm() {
    const { campaign, program, workflow } = this.props
    return {
      title: 't(New Email)',
      method: 'POST',
      action: this._getAction(),
      sections: [
        {
          fields: [
            { name: 'language', type: 'hidden', defaultValue: 'all'},
            { name: 'perspective', type: 'hidden', defaultValue: 'all' },
            ...program ? [
              { name: 'program_id', type: 'hidden', defaultValue: program.id }
            ] : [],
            ...workflow ? [
              { name: 'workflow_id', type: 'hidden', defaultValue: workflow.id },
              ...this._getWorkflowFields()
            ] : [],
            ...campaign ? [
              { name: `${campaign.type}_campaign_id`, type: 'hidden', defaultValue: campaign.id }
            ] : [],
            { label: 't(Title)', name: 'title', type: 'textfield', placeholder: 'Enter a title', required: true },
            ...program ? [
              { label: 't(Template)', name: 'template_id', type: 'dropdown', placeholder: 'Choose a template', endpoint: `/api/admin/team/programs/${program.id}/templates`, valueKey: 'id', textKey: 'title' },
              { label: 't(From)', name: 'sender_id', type: 'dropdown', placeholder: 'Choose a sender', endpoint: `/api/admin/team/programs/${program.id}/senders`, filter: { email_status: { $eq: 'verified' } }, valueKey: 'id', textKey: 'rfc822', required: true }  
            ] : [],
            { label: 't(Subject)', name: 'subject', type: 'textfield', emojis: true, maxLength: 150, required: true },
            { label: 't(Preview Text)', name: 'preview_text', type: 'textfield', maxLength: 150 }
          ]
        }
      ]
    }
  }

  _getAction() {
    const { action } = this.props
    if(action) return action
    return '/api/admin/automation/emails'
  }

  _getButton() {
    const { email } = this.state.config
    const { route } = this.props
    return {
      label: 'Design Email',
      className: 'link',
      route: route ? route(email) : `/admin/automation/emails/${email.id}/design`
    }
  }

  _getEndpoint() {
    const { endpoint, campaign, workflow } = this.props
    if(endpoint) return endpoint
    if(campaign) return `/api/admin/campaigns/${campaign.type}/${campaign.id}/emails`
    if(workflow) return `/api/admin/automation/workflows/${workflow.id}/emails`
  }

  _getScreenshot() {
    const { email } = this.state.config
    const { screenshot } = this.props
    return {
      engine: email.engine === 'mblocks' ? 'mblocks' : 'mjson',
      entity: screenshot ? screenshot(email) : `automation_emails/${email.code}`,
      width: 100,
      height: 75,
      screenshoted_at: email.screenshoted_at,
      updated_at: email.updated_at
    }
  }

  _getWorkflowFields() {
    const { workflow } = this.props
    const { event, form } = workflow
    if(form) {
      return [
        { name: 'form_id', type: 'hidden', defaultValue: form.id }
      ]
    }
    return []
  }

  _handleCancel() {
    this.props.onCancel()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleDone(config) {
    this.props.onDone({
      email_id: config.email.id,
      email: config.email,
      use_warming: config.use_warming === true
    })
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

}

export default Email
